import { useState } from 'react';
import styled from 'styled-components';

import { Flex, Space } from '@/components/base';
import Button from '@/components/Button/Button';
import Input from '@/components/Inputs/Input';
import PasswordInput from '@/components/Inputs/PasswordInput';
import { useModalContext } from '@/components/Modal/Modal';
import Heading from '@/components/Typography/Heading';
import Typo from '@/components/Typography/Typo';
import useColor from '@/hooks/domain/useColor';
import { modalStyle } from '@/styles/style';

type Props = {
  closeParentModal?: (...args: any) => void;
  onExportClick: (reason: string, password: string) => void;
};

const ExportModal = (props: Props) => {
  const color = useColor();
  const { closeModal } = useModalContext();

  const [password, setPassword] = useState('');
  const [reason, setReason] = useState('');
  const [exportError, setExportError] = useState('');

  const onExport = () => {
    if (password == '' || reason == '') {
      setExportError('Note and password cannot be empty. ');
    } else {
      props.closeParentModal?.();
      props.onExportClick(reason, password);
      closeModal();
    }
  };
  return (
    <ModalStyle d="column">
      <Heading type="h2">Export feedbacks</Heading>
      <Space h="32px" />
      <Flex j="flex-start">
        <Heading type="h3">Note</Heading>
      </Flex>
      <Space h="12px" />
      <Input
        sizeType="m"
        placeholder="Write a note for you and your team - a purpose of this file."
        name="download_resaon"
        value={reason}
        onChange={(e) => setReason(e.currentTarget.value)}
      />
      <Space h="24px" />
      <Flex j="flex-start">
        <Heading type="h3">Password</Heading>
      </Flex>
      <Space h="12px" />
      <PasswordInput
        sizeType="m"
        placeholder="Enter the password to protect the file."
        name="password"
        value={password}
        onChange={(e) => setPassword(e.currentTarget.value)}
      />
      <Space h="32px" />
      <Flex j="space-between" a="center">
        <Flex>
          {exportError && (
            <Typo type="label3" style={{ color: color.red600 }}>
              {exportError}
            </Typo>
          )}
        </Flex>
        <Flex g={6}>
          <Button sizeType="m" variant="secondary" onClick={closeModal}>
            Cancel
          </Button>
          <Button
            sizeType="m"
            style={{ padding: '8px 16px' }}
            onClick={onExport}
          >
            Export
          </Button>
        </Flex>
      </Flex>
    </ModalStyle>
  );
};

const ModalStyle = styled(Flex)`
  width: 600px;
  padding: 32px;
  ${modalStyle}
`;

export default ExportModal;
